/// <reference path="../../../../../gui/Builder.ts" />

namespace SPA
{
	export namespace Customer
	{
		export namespace gui
		{
			export abstract class CustomerBuilder<T extends Wollmilch.ComponentObject>
				extends SPA.gui.OrganizationBuilder<T>
			{

				protected constructor( object: T )
				{
					super( object );
				}

			}
		}
	}
}
